var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M334.885,98.803c-1.182,0-2.381-0.142-3.579-0.439c-7.951-1.97-12.801-10.013-10.83-17.965 l5.66-22.846l-99.892-24.752l-5.662,22.846c-1.97,7.951-10.021,12.801-17.965,10.83c-7.951-1.97-12.801-10.014-10.83-17.965 l9.229-37.244c1.97-7.952,10.02-12.8,17.965-10.83L347.67,32.325c3.818,0.946,7.105,3.369,9.136,6.739 c2.031,3.37,2.64,7.408,1.694,11.226l-9.229,37.245C347.597,94.288,341.542,98.803,334.885,98.803z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4B2B0"
    },
    points: "177.957,497.166 111.947,497.166 85.536,153.586 177.957,153.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4B2B0"
    },
    points: "361.805,497.166 295.795,497.166 295.795,153.586 388.217,153.586  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M445.095,146.789L74.039,54.848c-7.945-1.971-15.995,2.876-17.965,10.83 c-1.971,7.952,2.878,15.995,10.83,17.965l222.414,55.11h-111.36h-6.349H85.535c-4.131,0-8.075,1.724-10.883,4.754 c-2.808,3.032-4.223,7.096-3.907,11.217l26.412,343.581c0.593,7.728,7.038,13.696,14.79,13.696h66.011h46.21 c8.191,0,14.833-6.642,14.833-14.833c0-8.191-6.642-14.833-14.833-14.833h-31.377V168.419h88.169v328.747 c0,8.191,6.642,14.833,14.833,14.833h66.01c7.752,0,14.196-5.967,14.79-13.696l25.491-331.609l35.874,8.89 c1.199,0.297,2.397,0.439,3.579,0.439c6.657,0,12.712-4.515,14.385-11.269C457.897,156.802,453.048,148.759,445.095,146.789z  M101.552,168.419h61.573v313.914h-37.442L101.552,168.419z M348.068,482.333h-37.439V168.419H372.2L348.068,482.333z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/delete-2.4fe8ccc367e360735fd11b40f52fdc4a.svg";
export { ForwardRef as ReactComponent };